export default __webpack_public_path__ + "static/media/kitchen4-afterB-480w.fb59b429.avif";